import React, { useState } from 'react';
import styles from './reset-password.module.css';
import { useNavigate } from 'react-router-dom';
import { EMAIL_REGEX, NavigationPaths } from '../../constants';
import { AuthService } from '../../services';
import { Button, useNotification } from '../../components';
import { useTranslation } from 'react-i18next';

export const ResetPassword: React.FC = () => {
  const [email, setEmail] = useState<string>('');
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const { addNotification } = useNotification();
  const { t } = useTranslation();

  const isValidEmail = (email: string) => {
    return EMAIL_REGEX.test(email);
  };

  const handleResetPassword = async () => {
    if (!email) {
      addNotification({
        title: t('error'),
        message: t('insertValidEmail'),
        type: 'error',
      });
      return;
    }
    if (!isValidEmail(email)) {
      addNotification({
        title: t('error'),
        message: t('enterValidEmail'),
        type: 'error',
      });
      return;
    }
    setError(null);
    const { data: { data: { otc = false } = {} } = {} } =
      await AuthService.requestResetPassword(email);
    if (otc) {
      localStorage.setItem('setNewPassword', 'true');
      navigate(`${NavigationPaths.CONFIRMATION}?email=${encodeURIComponent(email)}`);
    }
  };

  return (
    <div className={styles['reset-container']}>
      <div className={styles['reset-box']}>
        <h1 className={styles['reset-title']}>{t('resetPassword')}</h1>
        <input
          type="email"
          placeholder={t('insertYourEmail')}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className={styles['reset-input']}
        />
        {error && <div className={styles['error-message']}>{error}</div>}
        <Button
          variant="primary"
          onClick={handleResetPassword}
          showArrow
          width="100%"
        >
          {t('sendEmail')}
        </Button>
      </div>
    </div>
  );
};
